export default __webpack_public_path__ + "static/duo-mobile-b85303656966110dc8fdcd0e966ccaca.webp";